import { inject } from '@angular/core';
import { Router, type CanActivateFn, type UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import type { AccountInfo } from '@azure/msal-browser';
import { resolveActiveAccount } from './active-account';
import { environment } from '../../../environments/environment';

// The "groups" claim is not part of MSAL's typed TokenClaims, so we extend it.
interface GroupTokenClaims {
	groups?: string[];
}

// Shared check used by both the route guard and the navigation link.
export function userHasEFilingAccess(account: AccountInfo | null): boolean {
	if (!account) return false;

	const claims = account.idTokenClaims as GroupTokenClaims | undefined;
	return claims?.groups?.includes(environment.msalConfig.groups.ar) ?? false;
}

export function userHasTestAccess(account: AccountInfo | null): boolean {
	if (!account) return false;

	const claims = account.idTokenClaims as GroupTokenClaims | undefined;
	return claims?.groups?.includes(environment.msalConfig.groups.test) ?? false;
}

export const eFilingGuard: CanActivateFn = (): boolean | UrlTree => {
	const msalService = inject(MsalService);
	const router = inject(Router);

	if (userHasEFilingAccess(resolveActiveAccount(msalService))) {
		return true;
	}

	return router.createUrlTree(['/']);
};
